import React, { useState, useEffect, useCallback } from "react";
import { Spinner } from "../../Components/Common/LoadingStates";
import { getRewardsClaims } from "../../helpers/fakebackend_helper";
import { AppPlacement, card, btnGhost, input, td, shortAddr, fmtNum, fmtDate, Badge, Muted, Pagination, Table, pageMetaOf, TOKEN } from "./shared";
import { apiError, listOf } from "./rewardsUtil";

const STATUSES = [
  { id: "", label: "All statuses" },
  { id: "awaiting_funding", label: "Awaiting funding" },
  { id: "awaiting_payout", label: "Awaiting payout" },
  { id: "paid", label: "Paid" },
  { id: "cancelled", label: "Cancelled" },
];
const STATUS_TONE = { awaiting_funding: "warn", awaiting_payout: "warn", paid: "success", cancelled: "error" };
const STATUS_LABEL = Object.fromEntries(STATUSES.filter((s) => s.id).map((s) => [s.id, s.label]));

export default function ClaimsTab({ flash }) {
  const [rows, setRows] = useState(null);
  const [meta, setMeta] = useState({ page: 1, total_pages: 1, total: 0 });
  const [page, setPage] = useState(1);
  const [status, setStatus] = useState("");

  const load = useCallback(async () => {
    setRows(null);
    try {
      const res = await getRewardsClaims({ status: status || undefined, page, page_size: 25 });
      setRows(listOf(res, ["claims", "rows", "items"]));
      setMeta(pageMetaOf(res));
    } catch (err) {
      flash("error", apiError(err, "Failed to load claims"));
      setRows([]);
    }
  }, [flash, page, status]);
  useEffect(() => { load(); }, [load]);

  return (
    <div style={card}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 12, marginBottom: 12, flexWrap: "wrap" }}>
        <h5 style={{ margin: 0 }}>Claims</h5>
        <div style={{ display: "flex", gap: 8 }}>
          <select style={{ ...input, width: 200 }} value={status} onChange={(e) => { setPage(1); setStatus(e.target.value); }} aria-label="Filter by status">
            {STATUSES.map((s) => <option key={s.id} value={s.id}>{s.label}</option>)}
          </select>
          <button style={btnGhost} onClick={load}>Refresh</button>
        </div>
      </div>
      <AppPlacement warn>users cannot see their claims or payout status in the current app (no claim history screen until the Rewards update ships).</AppPlacement>
      {rows === null ? <Spinner /> : rows.length === 0 ? (
        <Muted>No claims found.</Muted>
      ) : (
        <Table head={["Claim", "Wallet", "Points", `Paid (${TOKEN})`, "Status", "Payout tx", "Created", "Updated"]}>
          {rows.map((c) => {
            const wallet = c.wallet_address || c.wallet || c.to;
            return (
              <tr key={c.claim_id}>
                <td style={td}>#{c.claim_id}</td>
                <td style={td} title={wallet || ""}>{shortAddr(wallet)}</td>
                <td style={td}>{fmtNum(c.points ?? c.points_debited)}</td>
                <td style={td}>{c.token_amount === null || c.token_amount === undefined ? "-" : fmtNum(c.token_amount)}</td>
                <td style={td}><Badge tone={STATUS_TONE[c.status] || "warn"}>{STATUS_LABEL[c.status] || c.status}</Badge></td>
                <td style={{ ...td, fontFamily: "monospace" }} title={c.payout_tx_hash || ""}>{c.payout_tx_hash ? shortAddr(c.payout_tx_hash) : "-"}</td>
                <td style={td}>{fmtDate(c.created_at)}</td>
                <td style={td}>{fmtDate(c.updated_at)}</td>
              </tr>
            );
          })}
        </Table>
      )}
      <Pagination page={meta.page} totalPages={meta.total_pages} total={meta.total} onPage={setPage} />
    </div>
  );
}
